import { useEffect } from "react";

export default function Lightbox({ photo, onClose, onPrev, onNext, hasPrev, hasNext, coverIndex = 0, coverFull = false, onToggleCover }) {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft" && hasPrev) onPrev();
      if (e.key === "ArrowRight" && hasNext) onNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose, onPrev, onNext, hasPrev, hasNext]);

  if (!photo) return null;

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lb-close" onClick={onClose} aria-label="Close">×</button>

      <button
        className="lb-nav lb-prev"
        onClick={(e) => { e.stopPropagation(); if (hasPrev) onPrev(); }}
        disabled={!hasPrev}
        aria-label="Previous photo"
      >‹</button>

      <div className="lb-stage" onClick={(e) => e.stopPropagation()}>
        <img src={photo.medium || photo.thumb} alt={photo.originalName || photo.id} referrerPolicy="no-referrer" />
        <div className="lb-meta">
          <div className="lb-meta-left">
            {photo.exifDate && (
              <span>{new Date(photo.exifDate).toLocaleString("zh-TW")}</span>
            )}
            {photo.source === "drive" && <span>via Google Drive</span>}
          </div>
          <div className="lb-actions">
            {onToggleCover && (
              <button
                className={`lb-cover-btn ${coverIndex > 0 ? "is-cover" : ""}`}
                onClick={(e) => { e.stopPropagation(); if (!(coverFull && coverIndex === 0)) onToggleCover(); }}
                disabled={coverFull && coverIndex === 0}
                title={
                  coverIndex > 0 ? "點一下移出封面組"
                    : coverFull ? "封面組已滿（最多 4 張）"
                    : "加入封面組（顯示在首頁卡片）"
                }
              >
                {coverIndex > 0 ? `★ 封面 #${coverIndex}（移除）`
                  : coverFull ? "封面組已滿 (4)"
                  : "☆ 加入封面組"}
              </button>
            )}
            {photo.original && (
              <a
                className="lb-download"
                href={photo.original}
                download={photo.originalName || photo.id}
                target={photo.source === "drive" ? "_blank" : undefined}
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >↓ 下載原圖</a>
            )}
          </div>
        </div>
      </div>

      <button
        className="lb-nav lb-next"
        onClick={(e) => { e.stopPropagation(); if (hasNext) onNext(); }}
        disabled={!hasNext}
        aria-label="Next photo"
      >›</button>
    </div>
  );
}
